module.exports = {"370522001":"利津街道","370522002":"凤凰城街道","370522101":"北宋镇","370522102":"盐窝镇","370522103":"陈庄镇","370522104":"汀罗镇","370522201":"明集乡","370522206":"刁口乡","370522400":"利津县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370522.json
// module id = 1394
// module chunks = 0